import React from "react";
import Weather from "./edit-files/Weather.js";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <h1>Weather App</h1>
        <Weather defaultCity="London" />
        <footer>
          This project was coded by{" "}
          <a href="https://github.com/ToryK96">Tory King</a>
        </footer>
      </div>
    </div>
  );
}
